import { loginUser } from './authActions'
import * as types from '../constants/actionTypes'
import { authServer } from '../utils/fetchUtil';
import { hashHistory } from 'react-router'


export function saveRegState(creds) {
    return {
      type: types.SAVE_REG_STATE,
      creds: creds
    }
  }
  
  export function clearRegState() {
    return {
      type: types.CLEAR_REG_STATE
    }
  }
    
  function registerRequest(creds) {
    return {
      type: types.REGISTER_REQUEST,
      creds: creds
    }
  }

  export function registerError(message) {
    return {
        type: types.REGISTER_ERROR,
        message
    }
  }
  
  export function registerConfirmation() {
    return {
        type: types.REGISTER_SUCCESS,
        isRegistered: true
    }
  }
  

export function registerUser(creds) {  
  
    return dispatch => {
  
      dispatch(registerRequest(creds));
  
      let config = {
        method: 'POST',
        url: 'account/register',
        data: {
          Email: creds.email,
          Password: creds.password,
          ConfirmPassword: creds.passwordConfirm
        }
      };
  
      return authServer(config, dispatch)
        .then(response => {
  
          dispatch(registerConfirmation())
                
          dispatch(loginUser(creds.email, creds.password));
  
          hashHistory.push('/go/identity');
        })
        .catch(err => 
            console.log("Error: ", err)
        );
    }
  }



// WEBPACK FOOTER //
// ./src/actions/registrationActions.js